export default "__VITE_ASSET__BZvKXWvX__"